import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import OTPInput from "otp-input-react";
import { useForm } from 'react-hook-form';
import { ProgressBar } from 'components/ProgressBar';
import { useStorage64 } from 'hooks/useStorageBase64';
import { postNipIncode } from 'services/NipIncode';
import { decodeStorage, removeStorage } from 'functions/storageBase64';
import { ModalLoadingCredit } from 'components/Loading'
import { postRequestShort } from 'services/RequestShortIncode';
import { SolicitudFinalizadaMobile } from 'pages/Credito/10-SolicitarTarjeta/solicitudFinalizadaMobile';
import { ModalError } from 'components/Error/ErrorModal';
import { PantallaError500 } from 'pages/NuevoCredito/MensajesErrores/pantallaError500';



export function CreacionDeNip() {

    const history = useHistory();
    const [ loading, setLoading ] = useState(false);

    const profileData = decodeStorage('profileData');

    const [postNipGenerarRes, setPostNipGenerarRes] = useState(false);

    const [, setInfoNipStorage] = useStorage64('infoNipStorage', '');

    const [postRequestShortRes, setPostRequestShortRes] = useState(false);

    const infoPersonalRecabadaStorage = decodeStorage("infoPersonalRecabadaStorage")
    const infoDireccionStorage = decodeStorage("infoDireccionStorage");
    const infoOcupacionStorage = decodeStorage("infoOcupacionStorage");
    const infoIngmensualStorage = decodeStorage("infoIngmensualStorage");
    const infoPreguntasSinTelmexStorage = decodeStorage("infoPreguntasSinTelmexStorage");
    const EXTERNO = decodeStorage('EXTERNO');

    const infoLineaTelmexStorage = decodeStorage('infoLineaTelmexStorage');

    const [tipoDeRespuestaCredito, setTipoDeRespuestaCredito] = useState(0);

    const [lineaTelmex, setLineaTelmex] = useState(infoLineaTelmexStorage?.LineaTelmex);

    const [codigoOTP, setCodigoOTP] = useState("");

    const [codigoOTP2, setCodigoOTP2] = useState("");
    
    const [numFolio, setNumFolio] = useState("");

    const [codigoInvalido, setCodigoInvalido] = useState(false);

    const [codigoInvalido2, setCodigoInvalido2] = useState(false);

    const[validateOTP, setValidateOTP] = useState(false);

    const[mensajeErrorOTP, setMensajeErrorOTP] = useState(null);

    const[mensajeErrorOTP2, setMensajeErrorOTP2] = useState(null);

    const[verDigitos, setVerDigitos] = useState(false);

    const [postNipRes, setPostNipRes] = useState(false);

    const [postNipRegistroRes, setPostNipRegistroRes] = useState(false);

    const[nipComprobar, setNipComprobar] = useState("-----");

    const [disabled, setDisabled] = useState(true);

    const [disabled2, setDisabled2] = useState(true);

    const [codigoCorrectoRegistro, setCodigoCorrectoRegistro] = useState(false);

    // para el contador
    const [tiempo, setTiempo] = useState(60);
    // numero de minutos
    const [tiempo1, setTiempo1] = useState(0);
    const [estaVencido, setEstaVencido] = useState(false);
    let intervalRef = useRef();
    let intervalRef2 = useRef();

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Before Start  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
        generarNip();
    }, [])

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        //if (sectionActive === 'verificar') {
        //    window.location.href = `${BASE_PATH}`;
        //}
    }

    // decrementa de 1 en 1
    const decreaseNum = () => {
        setTiempo((prev) => prev - 1);
    }

    const decreaseNum2 = () => {
        setTiempo1((prev) => prev - 1);
    }

    // realiza cuenta regresiva de 60 seg.
    const activarContador = () => {
        setTiempo(60)
        clearInterval(intervalRef.current)
        intervalRef.current = setInterval(decreaseNum, 1000);
        clearInterval(intervalRef2.current)
        intervalRef2.current = setTimeout(decreaseNum2, 1000);
        setEstaVencido(false);
    }

    const resetearContador = () =>{
        setTiempo(60)
        clearInterval(intervalRef.current)
        intervalRef.current = setInterval(decreaseNum, 1000);
        clearInterval(intervalRef2.current)
        intervalRef2.current = setTimeout(decreaseNum2, 1000);
        setEstaVencido(false);
    }

    const restablecerContador = () =>{
        clearInterval(intervalRef.current);
        setEstaVencido(true);
        setNipComprobar("-----");
        setCodigoOTP("");
        setCodigoOTP2("");
        setDisabled(true);
        setDisabled2(true);
        setCodigoCorrectoRegistro(false);
    }

    // detiene el contador
    useEffect(() => {
        if(Number(tiempo) === 0 && tiempo1 >= 1){
            console.log("si pasa menos 1 en minutos")
            activarContador();
        }
        else if (Number(tiempo) === 0 && Number(tiempo1) === 0) {
            restablecerContador();
        }
    }, [tiempo]);

    const generarNip = () =>{
        setLoading(true); 
        postNipIncode({         
            "externalId": `${profileData?.idClaro}`,
            "nip": 0,
            "tipo": "GENERAR" 
        })
        .then(setPostNipGenerarRes)
    }

    useEffect(() => {
        if (postNipGenerarRes) {
            console.log("respuesta nip generar",postNipGenerarRes)
            if (postNipGenerarRes?.statusCode === 200) {
                if(postNipGenerarRes?.data?.respuestaVal === 'true'){
                    //se asigna nip y contador
                    setNipComprobar(`${postNipGenerarRes?.data?.nip}`);
                    setTiempo1(postNipGenerarRes?.data?.timeRefresh);
                    resetearContador();
                    setDisabled(false);
                    setLoading(false); 
                }else{
                    //mandar error modalito
                    setShowModalErr(true); 
                    setErrorCode(postNipGenerarRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse(postNipGenerarRes?.data?.codMen);
                    //reiniciar generar código
                    restablecerContador();
                    setLoading(false); 
                }
            }else if(postNipGenerarRes?.statusCode > 200 && postNipGenerarRes?.statusCode < 500){
                //mandar error modalito
                setShowModalErr(true); 
                setErrorCode(postNipGenerarRes?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(postNipGenerarRes?.data?.codMen);
                //reiniciar generar código
                restablecerContador();
                setLoading(false); 
            }else{
                setErrorCode(postNipGenerarRes?.statusCode);
                setLoading(false);
            }
        }
    }, [postNipGenerarRes])

    const cancelar = () => {
        //history.replace(`${BASE_PATH}`);
        history.goBack(-1);
    }

    const [permisos, setPermisos] = useState(false);

    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            permisos: false,
            codigoOTP: 0
        }
    });

    const valPermisos = {
        required: 'Campo obligatorio',
    };

    const valOTP = {
        required: 'Campo obligatorio',
    };

    const valOTP2 = {
        required: 'Campo obligatorio',
    };

    const seleccionarPermisos = (e) => {
        setPermisos(e.target.value);
    };



    // mensages de errores nip
    useEffect(() => {
        
        if(handlerIsNotSame(codigoOTP.split(''))){
            setCodigoInvalido(true);
            setMensajeErrorOTP({error: "Los valores no coinciden"});
        }
        else if(codigoOTP?.length === 5 && mensajeErrorOTP === null && !codigoCorrectoRegistro){
            //mandar a registrar el código
            setLoading(true); 
            postNipIncode({         
                "externalId": `${profileData?.idClaro}`,
                "nip": codigoOTP,
                "tipo": "REGISTRO" 
            })
            .then(setPostNipRegistroRes)
        }
        else{
            setCodigoInvalido(false);
            setMensajeErrorOTP(null);
        }

        
        if(validateOTP === true){
            if(codigoOTP?.length === 0){
                setCodigoInvalido(true);
                setMensajeErrorOTP({error: "Campos vacios"});
            }
        }
        
            
    }, [codigoOTP,validateOTP])

    const handlerIsNotSame = (arrayNumbers) => {
        let nRepeated = 0;
        arrayNumbers.forEach((item, index)=>{
            if(item !== nipComprobar[index]){
                nRepeated++
            }
        });
        if(nRepeated > 0){
            return true
        } else{
            return false
        }
    };

    useEffect(() => {
        if (postNipRegistroRes) {
            console.log("respuesta nip registro",postNipRegistroRes)
            if (postNipRegistroRes?.statusCode === 200) {
                if(postNipRegistroRes?.data?.respuestaVal === 'true'){
                    //quitar disabled de codigo2 poner en codigo1, y mandar mensage
                    setDisabled2(false);
                    setDisabled(true);
                    setCodigoCorrectoRegistro(true);
                    setLoading(false); 
                }else{
                    //mandar error modalito
                    setShowModalErr(true); 
                    setErrorCode(postNipRegistroRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse(postNipRegistroRes?.data?.codMen);
                    //reiniciar generar código
                    restablecerContador();
                    setLoading(false); 
                }
            }else if(postNipRegistroRes?.statusCode > 200 && postNipRegistroRes?.statusCode < 500){
                //mandar error modalito
                setShowModalErr(true); 
                setErrorCode(postNipRegistroRes?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(postNipRegistroRes?.data?.codMen);
                //reiniciar generar código
                restablecerContador();
                setLoading(false); 
            }else{
                setErrorCode(postNipRegistroRes?.statusCode);
                setLoading(false);
            }
        }
    }, [postNipRegistroRes])

    // mensages de errores nip2
    useEffect(() => {
        
        if(handlerIsNotSame(codigoOTP2.split(''))){
            setCodigoInvalido2(true);
            setMensajeErrorOTP2({error: "Los valores no coinciden"});
        } 
        else{
            setCodigoInvalido2(false);
            setMensajeErrorOTP2(null);
        }
        
        if(validateOTP === true && codigoCorrectoRegistro === true){
            if(codigoOTP2?.length === 0){
                setCodigoInvalido2(true);
                setMensajeErrorOTP2({error: "Campos vacios"});
            }
            else if(codigoOTP2?.length < 5){
                setCodigoInvalido2(true);
                setMensajeErrorOTP2({error: "Llena los campos"});
            }
        }
        
            
    }, [codigoOTP2,validateOTP])

    const sendFormInformacionNip = data => {
        //valida nip antes
        if(!codigoInvalido2 && !codigoInvalido && codigoCorrectoRegistro){
            console.log(data);
            console.log("se envia")
            setLoading(true); 
            postNipIncode({         
                "externalId": `${profileData?.idClaro}`,
                "nip": codigoOTP,
                "tipo": "VALIDAR" 
            })
            .then(setPostNipRes)
        }
    };

     //postNipIncode res
    useEffect(() => {
        if (postNipRes) {
            console.log("respuesta nip",postNipRes)
            if (postNipRes?.statusCode === 200) {
                if(postNipRes?.data?.respuestaVal === 'true'){ 
                    setLoading(true); 
                    let data_request = {};
                    //console.log({"infoDireccionStorage": infoDireccionStorage,"infoOcupacionStorage": infoOcupacionStorage,"infoIngmensualStorage":infoIngmensualStorage,"infoPreguntasSinTelmexStorage":infoPreguntasSinTelmexStorage});
                    //Request-short
                    //seteavariables cuando tine linea telmex buena o excelente
                    let variables = {
                        "STarjeta": "",
                        "SHipotecario": "",
                        "SAutomotriz": ""
                    }; 
                    //si cuanta con linea telmex
                    if(!lineaTelmex){
                        data_request = {...infoPersonalRecabadaStorage,...infoDireccionStorage, ...infoOcupacionStorage, ...infoIngmensualStorage, ...variables};
                    }else{
                        data_request = {...infoPersonalRecabadaStorage,...infoDireccionStorage, ...infoOcupacionStorage, ...infoIngmensualStorage, ...infoPreguntasSinTelmexStorage};
                    }
                    console.log("objeto unido data_request:",data_request);
                    //setSeEnvia(JSON.stringify(data_request));
                    postRequestShort(data_request)
                    .then(setPostRequestShortRes)
                }else{
                    //mandar error modalito
                    setShowModalErr(true); 
                    setErrorCode(postNipRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse(postNipRes?.data?.codMen);
                    //reiniciar generar código
                    restablecerContador();
                    setLoading(false); 
                }
            }else if(postNipRes?.statusCode > 200 && postNipRes?.statusCode < 500){
                //mandar error modalito
                setShowModalErr(true); 
                setErrorCode(postNipRes?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(postNipRes?.data?.codMen);
                //reiniciar generar código
                restablecerContador();
                setLoading(false); 
            }else{
                setErrorCode(postNipRes?.statusCode);
                setLoading(false);
            }

        }
    }, [postNipRes])

    //RequestShortRes res
    useEffect(() => {
        if (postRequestShortRes) {
            console.log("respuesta postRequestShortRes:",postRequestShortRes)
            console.log("respuesta postRequestShortRes data:",postRequestShortRes?.data)
            if(postRequestShortRes?.statusCode === 200){
                setLoading(false); 
                //Solicitud pendiende de aprobar
                if(postRequestShortRes?.data?.tipo === "0"){
                    setNumFolio({folio: postRequestShortRes?.data?.folio});
                    setTipoDeRespuestaCredito(1);
                    removeAllStoreIncode();
                }
                //Crédito aprobado en automático
                //else if(postRequestShortRes?.data?.tipo === 2){
                //    setTipoDeRespuestaCredito(2);
                    //setIdCredito(postRequestShortRes?.data?.idCredito)
                //}
                //Solicitud Rechazada Registro duplicado
                else if(postRequestShortRes?.data?.tipo === "1"){
                    history.push(`${BASE_PATH}${SUB_DIRECTORY}error-credito/solicitud-rechazada-tipo1`);
                    //setObjRespuestaError(postRequestShortRes?.data);    
                    //setTipoDeRespuestaCredito(3);
                    removeAllStoreIncode();
                }
                //No coincide documento y Selfie, Pertenece a lista negra
                else if(postRequestShortRes?.data?.tipo === "2"){
                    history.push(`${BASE_PATH}${SUB_DIRECTORY}error-credito/solicitud-rechazada-tipo2`);
                    //setObjRespuestaError(postRequestShortRes?.data);    
                    //setTipoDeRespuestaCredito(3);
                    removeAllStoreIncode();
                }
                else{
                    //mandar error modalito
                    setShowModalErr(true);
                    setErrorCode(postRequestShortRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse(`Variable 'tipo' vacía o inexistente, ${postRequestShortRes?.data?.codMen}`);
                    setLoading(false);
                    //reiniciar generar código
                    restablecerContador();
                    setLoading(false); 
                }
            }else if(postRequestShortRes?.statusCode > 200 && postRequestShortRes?.statusCode < 500){
                //mandar error modalito
                setShowModalErr(true); 
                setErrorCode(postRequestShortRes?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(postRequestShortRes?.data?.codMen);
                //reiniciar generar código
                restablecerContador();
                setLoading(false); 
            }else{
                setErrorCode(postRequestShortRes?.statusCode);
                setLoading(false);
            }

        }
    }, [postRequestShortRes])

    const verificarValidacionesOTP = () =>{
        setValidateOTP(true);
    }

    const handlerVerDigitos = () =>{
        setVerDigitos(!verDigitos);
    }

    const [show,setShow] = useState(false);

    const [descripcion, setDescripcion] = useState(`
        Al ingresar el código, autorizo expresamente
        a Claroshop.com, S.A.P.I. de C.V. para realizar las investigaciones
        sobre mi comportamiento crediticio en las
        Sociedades de Información Crediticia (SIC) que
        considere oportunas. Conozco la naturaleza y el
        alcance de la información que se solicitará, el uso
        que se le dará y que se pueden hacer consultas
        periódicas de mi historial crediticio. Estoy de
        acuerdo en que esta autorización será válida por 3
        años a partir de hoy, y es apropiada siempre que
        mantengamos una relación legal. Acepto que este
        documento sigue siendo propiedad de Claroshop.com, S.A.P.I. de C.V. para efectos de control y cumplimiento
        del artículo 28 de la LRSIC.`);
    const [descripcionRecortada, setDescripcionRecortada] = useState("");

    const ver = () =>{
        setShow(!show);
    }

    
    useEffect(()=>{
        if(show){
            setDescripcionRecortada(descripcion);
        }else{
            setDescripcionRecortada(`${descripcion.substr(0, 158)}...`)
        }
    },[show])

    const removeAllStoreIncode = () =>{
        removeStorage("infoPersonalStorageIncode");
        removeStorage("infoPersonalRecabadaStorage")
        removeStorage("infoDireccionStorage");
        removeStorage("infoOcupacionStorage");
        removeStorage("infoIngmensualStorage");
        removeStorage("infoPreguntasSinTelmexStorage");
        removeStorage('infoLineaTelmexStorage');
    }


    return (
        <>
            { loading && <ModalLoadingCredit /> }
            {errorCode >= 500
                ? <PantallaError500 />
                :tipoDeRespuestaCredito === 0 && 
                <>
                    <div className="homeMobile">
                    {
                        EXTERNO ? null : <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />
                    }
                        <main className='nuevoCredito ultimosPasos'>
                            <ProgressBar progress={100} />
                            <form onSubmit={handleSubmit(sendFormInformacionNip)}>
                                <section className="sectionPrincipalBeneficios fullBottom">
                                    <p className='tLeft bold'>Para finalizar, ingresa el siguiente código:</p>

                                    <h1 className='bold codigo-nip'>{nipComprobar}</h1>

                                    <p className={estaVencido ? 'subtitle-codigo colorRojo' : 'colorGris subtitle-codigo'}>
                                        {estaVencido ? "Tu código ha vencido. " : "Tu código vence en:"} 
                                        {estaVencido ? <span className='colorAzul' onClick={generarNip}>Generar uno nuevo</span> : null}
                                    </p>

                                    <p className={estaVencido ? 'showDigits clockRed colorRojo' : 'showDigits clock'}>
                                        0{tiempo1}:{tiempo === 60 ? "00" : tiempo.toString().length === 1 ? `0${tiempo}`: tiempo }
                                    </p>

                                    <div className="contenido">
                                        <div className="contenedorLandingBeneficios">

                                            <div className=''>
                                                
                                                <p className='tLeft colorGris justify-text'>
                                                    {descripcionRecortada}
                                                </p>
                                                {show ?
                                                    <p onClick={ver} className="tLeft bold ver">Leer menos</p>
                                                    :
                                                    <p onClick={ver} className="tLeft bold ver">Leer más</p>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                
                                    <p className='tLeft colorGris subtitle-codigo'>Ingresa el código</p>

                                    <OTPInput
                                        value={codigoOTP}
                                        onChange={setCodigoOTP}
                                        ref={register(valOTP)}
                                        autoFocus
                                        OTPLength={5}
                                        otpType="number"
                                        disabled={disabled}
                                        className="contenedorOTP"
                                        inputClassName={codigoInvalido ? "inputOTP errorActivo" : "inputOTP"}
                                    />

                                    {codigoCorrectoRegistro 
                                        ? <div className="exito check-nip"> Código Correcto </div>
                                        : null
                                    }

                                    {mensajeErrorOTP && mensajeErrorOTP?.error 
                                        ? <div className="error check-nip"> {mensajeErrorOTP?.error} </div>
                                        : null
                                    }

                                    <p className='tLeft colorGris subtitle-codigo'>Confirma el código</p>

                                    <OTPInput
                                        value={codigoOTP2}
                                        onChange={setCodigoOTP2}
                                        ref={register(valOTP2)}
                                        autoFocus
                                        OTPLength={5}
                                        otpType="number"
                                        disabled={disabled2}
                                        className="contenedorOTP"
                                        inputClassName={codigoInvalido2 ? "inputOTP errorActivo" : "inputOTP"}
                                    />

                                    {mensajeErrorOTP2 && mensajeErrorOTP2?.error 
                                        ? <div className="error check-nip"> {mensajeErrorOTP2?.error} </div>
                                        : null
                                    }
                                    
                                    
                                </section>
                                <div className="boxBtnSolicitar marginBottom30">
                                    <button className="btnSolicitar" onClick={verificarValidacionesOTP}>Comenzar</button>
                                </div>
                            </form>
                            
                        </main>
                    </div>
                </>
                }

                {showModalErr &&
                    <ModalError
                        errorCode={errorCode}
                        section={sectionActive}
                        message={messageResponse}
                        handleClose={handleCloseErr}
                    />
                }

                {tipoDeRespuestaCredito === 1 && <SolicitudFinalizadaMobile numFolio={numFolio}/>}
        
        </>
    )
}